import { getToken } from "./user-service";
const url = "/api/v1/marketplace";


// get rewards
export const getAirportRetailers = async (iata) => {
    const new_url = url + "/retailers/" + iata;
    const token = await getToken();

    return new Promise(async (resolve, reject) => {
        try {
            const response = await fetch(new_url, {
                method: "GET",
                headers: { "Firebase-UID": token },
            });
            let json = await response.json();

            // check for errors
            if (response.status >= 400) {
                // bad request invalid fields
                throw new Error(
                    "Issue getting airport retailers a reward using the details you provided."
                );
            }
            if (response.status >= 500) {
                // network error
                throw new Error(
                    "Issue with network connection, please try again later."
                );
            }

            // console.log('response : ', json)
            resolve(json);
        } catch (e) {
            reject(e);
        }
    });
};

export const postRetailer = async (retailer) => {
    const new_url = "/api/v1/marketplace/retailers";

    const token = await getToken();
    return new Promise(async (resolve, reject) => {
        try {
            const response = await fetch(new_url, {
                method: "POST",
                body: JSON.stringify(retailer),
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                    "firebase-uid": token,
                },
            });
            let json = await response.json();

            if (response.status >= 400) {
                // bad request invalid fields
                throw new Error(
                    "Issue creating a retailer using the details you provided."
                );
            }
            if (response.status >= 500) {
                // network error
                throw new Error(
                    "Issue with network connection, please try again later."
                );
            }

            resolve(json);
        } catch (e) {
            reject(e);
        }
    });
};

export const updateRetailer = async (retailer) => {
    const new_url = "/api/v1/marketplace/retailers/" + retailer._id;

    const token = await getToken();
    return new Promise(async (resolve, reject) => {
        try {
            const response = await fetch(new_url, {
                method: "PUT",
                body: JSON.stringify(retailer),
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                    "firebase-uid": token,
                },
            });

            let json = await response.json();

            if (response.status >= 400) {
                // bad request invalid fields
                throw new Error(
                    "Issue updating a retailer using the details you provided."
                );
            }
            if (response.status >= 500) {
                // network error
                throw new Error(
                    "Issue with network connection, please try again later."
                );
            }

            resolve(json);
        } catch (e) {
            reject(e);
        }
    });
};

export const deleteRetailer = async (id) => {
    const new_url = url + "/retailers/" + id;

    const token = await getToken();
    return new Promise(async (resolve, reject) => {
        try {
            const response = await fetch(new_url, {
                method: "DELETE",
                headers: { "Firebase-UID": token },
            });

            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw new Error("Bad request details");
            }

            resolve(json);
        } catch (e) {
            reject(new Error("Error deleting the Retailer"));
        }
    });
};


export const getRetailerByUserId = async (id) => {

    const url = "/api/v1/marketplace/retailers/retailer/" + id;

    //console.log("getRetailerByUserId url: ", url);
    
    return new Promise(async (resolve, reject) => {
        try {
            //const token = await getToken();
            const response = await fetch(url, {
                method: "GET",
                headers: { "Firebase-UID": '123456789' },
            });
            let json = await response.json();
            //console.log('response: ', response)
            if (response.status >= 400 && response.status < 600) {
                throw new Error("Bad retailer details");
            }
            resolve(json);
        } catch (e) {
            reject(new Error("error getting retailer"));
        }
    });
};


//#region firebase

// get retailer from firebase using retailer id
export const getRetailerById = async (id) => {

    const url = "/api/v1/marketplace/retailers/getWebsiteRetailers/" + id;
    
    return new Promise(async (resolve, reject) => {
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: { "Firebase-UID": '123456789' },
            });

            let json = await response.json();
            //console.log('response: ', response)

            if (response.status >= 400 && response.status < 600) {
                throw new Error("Bad retailer details");
            }

            resolve(json);

        } catch (e) {
            reject(new Error("error getting retailer"));
        }
    });
};

// get retailers from firebase using iata
export const getRetailersByIata = async (iata) => {

    const url = "/api/v1/marketplace/retailers/getWebsiteRetailersByIata/" + iata;
    
    return new Promise(async (resolve, reject) => {
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: { "Firebase-UID": '123456789' },
            });

            let json = await response.json();
            //console.log('response: ', response)

            if (response.status >= 400 && response.status < 600) {
                throw new Error("Bad retailer details");
            }

            resolve(json);

        } catch (e) {
            reject(new Error("error getting retailer"));
        }
    });
};